export const leaseRateMappings = {
  dollars_per_month: {
    max: 'q[leases_total_normalized_lease_rate_lteq]',
    min: 'q[leases_total_normalized_lease_rate_gteq]',
    conversion: 1,
    label: 'per month'
  },
  dollars_per_sf_per_month: {
    max: 'q[leases_normalized_lease_rate_lteq]',
    min: 'q[leases_normalized_lease_rate_gteq]',
    conversion: 1,
    label: '/SF/month'
  },
  dollars_per_acre_per_month: {
    max: 'q[leases_normalized_lease_rate_lteq]',
    min: 'q[leases_normalized_lease_rate_gteq]',
    conversion: 1 / 43560,
    label: '/Acre/month'
  },
  dollars_per_year: {
    max: 'q[leases_total_normalized_lease_rate_lteq]',
    min: 'q[leases_total_normalized_lease_rate_gteq]',
    conversion: 1 / 12,
    label: 'per year'
  },
  dollars_per_sf_per_year: {
    max: 'q[leases_normalized_lease_rate_lteq]',
    min: 'q[leases_normalized_lease_rate_gteq]',
    conversion: 1 / 12,
    label: '/SF/year'
  },
  dollars_per_acre_per_year: {
    max: 'q[leases_normalized_lease_rate_lteq]',
    min: 'q[leases_normalized_lease_rate_gteq]',
    conversion: 1 / (43560 * 12),
    label: '/Acre/year'
  }
};

export const filterKeyMappings = {
  acresStabilized: ['minAcresStabilized', 'maxAcresStabilized'],
  apnNumber: ['apnNumber'],
  availableRailProvider: ['availableRailProvider'],
  availableSF: ['minAvailableSF', 'maxAvailableSF'],
  beds: ['minBeds', 'maxBeds'],
  baths: ['minBaths', 'maxBaths'],
  bridgeCraneSpan: ['minBridgeCraneSpan', 'maxBridgeCraneSpan'],
  currentCity: ['currentCity'],
  buildingNumber: ['buildingNumber'],
  buildingSize: ['minBuildingSize', 'maxBuildingSize'],
  capRate: ['minCapRate', 'maxCapRate'],
  ceilingHeight: ['minCeilingHeight', 'maxCeilingHeight'],
  county: ['county'],
  driveThroughAccess: ['driveThroughAccess'],
  jibCraneSpan: ['minJibCraneSpan', 'maxJibCraneSpan'],
  leaseDate: ['minLeaseDate', 'maxLeaseDate'],
  leaseExecutionDate: ['minLeaseExecutionDate', 'maxLeaseExecutionDate'],
  leaseExpirationDate: ['minLeaseExpirationDate', 'maxLeaseExpirationDate'],
  leasePrice: ['minLeasePrice', 'maxLeasePrice'],
  leaseSize: ['minLeaseSize', 'maxLeaseSize'],
  leaseSpaceType: ['leaseSpaceType'],
  leaseType: ['leaseType'],
  lotBorderType: ['lotBorderType'],
  lotSize: ['minLotSize', 'maxLotSize'],
  lotStabilization: ['lotStabilization'],
  mortgageAmount: ['minMortgageAmount', 'maxMortgageAmount'],
  mortgageRecordedDate: ['minMortgageRecordedDate', 'maxMortgageRecordedDate'],
  numBridgeCranes: ['minNumBridgeCranes', 'maxNumBridgeCranes'],
  numJibCranes: ['minNumJibCranes', 'maxNumJibCranes'],
  numKeys: ['minNumKeys', 'maxNumKeys'],
  numUnits: ['minNumUnits', 'maxNumUnits'],
  market: ['market'],
  marketRent: ['minMarketRent', 'maxMarketRent'],
  subMarket: ['subMarket'],
  microMarket: ['microMarket'],
  ready: ['ready'],
  readyCapacity: ['minReadyCapacity', 'maxReadyCapacity'],
  readySpan: ['minReadySpan', 'maxReadySpan'],
  rent: ['minRent', 'maxRent'],
  salesDate: ['minSalesDate', 'maxSalesDate'],
  salesPrice: ['minSalesPrice', 'maxSalesPrice'],
  served: ['served'],
  servedRailProvider: ['servedRailProvider'],
  sfPrice: ['minSfPrice', 'maxSfPrice'],
  size: ['minSize', 'maxSize'],
  state: ['state'],
  street: ['street'],
  unitPrice: ['minUnitPrice', 'maxUnitPrice'],
  yearBuilt: ['minYearBuilt', 'maxYearBuilt'],
  zip: ['zip'],
};

export const filterLabelMappings = {
  acresStabilized: 'Acres Stabilized',
  apnNumber: 'APN Number',
  availableSF: 'Available SF',
  baths: 'Baths',
  beds: 'Beds',
  bridgeCraneSpan: 'Bridge Crane Span',
  currentCity: 'City',
  buildingNumber: 'Building Number',
  buildingSize: 'Building Size',
  capRate: 'Cap Rate',
  ceilingHeight: 'Ceiling Height',
  investmentType: 'Investment Type',
  lotStabilization: 'Lot Stabilization',
  lotBorderType: 'Lot Border Type',
  servedRailProvider: 'Served',
  availableRailProvider: 'Available',
  driveThroughAccess: 'Building Drive Through Access',
  county: 'County',
  hasActiveDeals: 'Active Deals',
  hasActiveEdgeProjects: 'Active Listings',
  jibCraneSpan: 'Jib Crane Span',
  leaseDate: 'Lease Start Date',
  leaseExecutionDate: 'Lease Execution Date',
  leaseExpirationDate: 'Lease Expiration Date',
  leasePrice: 'Lease Rate',
  leaseSize: 'Lease Space Size (SF)',
  leaseSpaceType: 'Lease Space Type',
  leaseType: 'Lease Type',
  lotSize: 'Lot Size',
  marketRent: 'Market Rent ($)',
  mortgageAmount: 'Mortgage Amount',
  mortgageRecordedDate: 'Mortgage Recorded Date',
  numBridgeCranes: 'Number of Bridge Cranes (Total)',
  numJibCranes: 'Number of Jib Cranes (Total)',
  numKeys: 'Number of Keys',
  numUnits: 'Number of Units',
  market: 'Market',
  microMarket: 'Micro Market',
  readyCapacity: 'Ready Capacity',
  ready: 'Ready',
  readySpan: 'Ready Span',
  rent: 'Rent ($)',
  salesDate: 'Sale Date',
  salesPrice: 'Sales Price',
  served: 'Served',
  sfPrice: 'Price/SF',
  size: 'Size (SF)',
  state: 'State',
  street: 'Street',
  subMarket: 'Submarket',
  unitPrice: 'Price/Unit',
  yearBuilt: 'Year Built',
  zip: 'Zip'
};

export const propertyAttributes = [
  'address',
  'amenities',
  'apn',
  'assessedValue',
  'assessmentYear',
  'bayDepth',
  'bestUse',
  'broadband',
  'buildingClass',
  'buildingDescription',
  'buildingSize',
  'buildingSizeLabel',
  'cable',
  'cableDescription',
  'ceilingHeight',
  'ceilingHeightMin',
  'ceilings',
  'centralHvac',
  'centrixEquipped',
  'city',
  'columnSpace',
  'condition',
  'constructionDescription',
  'cornerProperty',
  'corridors',
  'countryNameOverride',
  'county',
  'craneDescription',
  'createdAt',
  'createdBy',
  'crossStreets',
  'dealStatusLabel',
  'deletedAt',
  'displayName',
  'dockDoorDescription',
  'dockHighDoors',
  'driveInBays',
  'easementsDescription',
  'elevators',
  'environmentalIssues',
  'estimatedLeaseRate',
  'estimatedLeaseRateDuration',
  'estimatedLeaseRateUnits',
  'estimatedMarketValue',
  'exteriorDescription',
  'exteriorWalls',
  'floorCoverings',
  'foundation',
  'framing',
  'freeStanding',
  'freightElevator',
  'frontage',
  'gas',
  'gasDescription',
  'gradeLevelDoors',
  'grossBuildingArea',
  'handicapAccess',
  'hvac',
  'industrialOfficeSpace',
  'interiorDescription',
  'investmentType',
  'irrigation',
  'irrigationDescription',
  'landscaping',
  'latitude',
  'lastUpdatedAt',
  'lastUpdatedBy',
  'laundryDescription',
  'leedCertified',
  'loadFactor',
  'loadingDescription',
  'longitude',
  'lotDepth',
  'lotSize',
  'lotSizeUnits',
  'market',
  'measurements',
  'mezzanine',
  'modelType',
  'mortgageAmount',
  'mortgageRecordedDate',
  'name',
  'numberOfBuildings',
  'numberOfCranes',
  'numberOfElevators',
  'numberOfEscalators',
  'numberOfLots',
  'numberOfParkingSpaces',
  'numberOfUnits',
  'occupancyPct',
  'officeBuildout',
  'overheadDoorHeight',
  'overrideLatitudeAndLongitude',
  'ownerEmail',
  'ownerName',
  'ownerPhoneNormalized',
  'ownerPhoneNumber',
  'parkingDescription',
  'parkingPricePerMonth',
  'parkingRatio',
  'parkingType',
  'plumbingDescription',
  'power',
  'powerDescription',
  'propertyTypeLabelOverride',
  'propertyTypeLabels',
  'railAccess',
  'renovated',
  'restrooms',
  'retailClientele',
  'roof',
  'securityGuard',
  'sewer',
  'soilType',
  'sprinklerDescription',
  'sprinklers',
  'state',
  'stories',
  'submarket',
  'databaseName',
  'telephone',
  'telephoneDescription',
  'topography',
  'township',
  'trafficCount',
  'trafficCountFrontage',
  'trafficCountStreet',
  'trailerParking',
  'typicalFloorSize',
  'updatedAt',
  'utilitiesDescription',
  'vacancyPct',
  'walls',
  'warehousePct',
  'water',
  'waterDescription',
  'waterfront',
  'website',
  'yearBuilt',
  'zip',
  'zoning'
];

export const initialState = {
  associationFilters: {},
  addressFilter: {
    buildingNumber: '',
    cities: [],
    currentCity: '',
    county: '',
    market: '',
    microMarket: '',
    state: '',
    street: '',
    subMarket: '',
    zip: ''
  },
  propertyFilter: {
    apnNumber: '',
    lotUnits: 'sf',
    minAvailableSF: '',
    maxAvailableSF: '',
    minLotSize: '',
    maxLotSize: '',
    maxBuildingSize: '',
    minBuildingSize: '',
    maxYearBuilt: '',
    minYearBuilt: '',
    minNumUnits: '',
    maxNumUnits: '',
    minCeilingHeight: '',
    maxCeilingHeight: '',
    maxMortgageAmount: '',
    minMortgageAmount: '',
    maxMortgageRecordedDate: '',
    minMortgageRecordedDate: ''
  },
  saleFilter: {
    maxSalesPrice: '',
    minSalesPrice: '',
    maxSalesDate: '',
    minSalesDate: '',
    maxLeasePrice: '',
    minLeasePrice: '',
    maxLeaseDate: '',
    minLeaseDate: '',
    maxLeaseExecutionDate: '',
    minLeaseExecutionDate: '',
    maxLeaseExpirationDate: '',
    minLeaseExpirationDate: '',
    maxSfPrice: '',
    minSfPrice: '',
    maxUnitPrice: '',
    minUnitPrice: '',
    maxCapRate: '',
    minCapRate: '',
    leaseType: '',
    leaseSpaceType: '',
    leaseRateUnits: 'dollars_per_month'
  },
  multifamilyFilter: {
    maxBeds: '',
    maxBaths: '',
    maxSize: '',
    maxRent: '',
    maxMarketRent: '',
    minBeds: '',
    minBaths: '',
    minSize: '',
    minRent: '',
    minMarketRent: ''
  },
  industrialFilter: {
    availableRailProvider: '',
    driveThroughAccess: false,
    lotBorderType: '',
    lotStabilization: '',
    maxAcresStabilized: '',
    maxBridgeCraneSpan: '',
    maxJibCraneSpan: '',
    maxNumBridgeCranes: '',
    maxNumJibCranes: '',
    maxReadyCapacity: '',
    maxReadySpan: '',
    minAcresStabilized: '',
    minBridgeCraneSpan: '',
    minJibCraneSpan: '',
    minNumBridgeCranes: '',
    minNumJibCranes: '',
    minReadyCapacity: '',
    minReadySpan: '',
    ready: false,
    served: false,
    servedRailProvider: ''
  },
  availabilities: [],
  assetClasses: [],
  buildingClasses: [],
  investmentTypes: [],
  searchText: '',
  tags: [],
  tagIds: [],
  propertyPage: 1
};

export const TRANSFER_ACTION_TYPE = {
  COPY: 'copy',
  MOVE: 'move'
};

export const TRANSFER_MODEL_TYPE = 'research_properties';